import { render, staticRenderFns } from "./ParticipantDriverCustomer.vue?vue&type=template&id=23c05356"
import script from "./ParticipantDriverCustomer.vue?vue&type=script&lang=js"
export * from "./ParticipantDriverCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports